"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useStyle = () => {
    const theme = (0, material_1.useTheme)();
    const container = {
        width: '100%',
        height: '24px ',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '2px',
    };
    const iconStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    };
    const lineStyle = {
        width: '100%',
        backgroundColor: theme.qlub.palette.dim.main,
        height: '2px',
    };
    const activeLineStyle = {
        backgroundColor: theme.qlub.palette.iris.main,
    };
    const emptyIconStyle = {
        color: theme.qlub.palette.dim.main,
    };
    const activeIconStyle = {
        color: theme.qlub.palette.iris.main,
    };
    const typographyStyle = Object.assign(Object.assign({}, theme.qlub.typography.caption_overline), { fontFamily: 'inherit' });
    return {
        container,
        lineStyle,
        iconStyle,
        emptyIconStyle,
        activeIconStyle,
        activeLineStyle,
        typographyStyle,
    };
};
exports.default = useStyle;
